import React, { useState } from 'react';
import { addFormatApi } from '_services/accountsServices/branchServices';
import { CommonInput, CommonTextarea, CrossButton } from 'components';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import toast from 'react-hot-toast';
import { RxDragHandleDots2 } from 'react-icons/rx';
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { Format1, Format2, Format3, Format4, Format5, Format6, Format7 } from 'pages';


// ── Cross Icon ──────────────────────────────────────────────────────────────
const CrossIcon = () => (
    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
        <path
            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
            fill="black"
        />
    </svg>
);

// ── SortableItem ─────────────────────────────────────────────────────────────
function SortableItem({ item, onToggleMain, onToggleSelect }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.name });

    return (
        <li
            ref={setNodeRef}
            style={{ transform: CSS.Transform.toString(transform), transition }}
            className="__tabFields_item"
            {...attributes}
            {...listeners}
        >
            <span className="__tabFields_dragIcon">
                <RxDragHandleDots2 />
            </span>

            <input
                type="checkbox"
                id={item.name}
                name="LR_Details"
                checked={item.check}
                onChange={() => onToggleMain(item.name)}
            />
            <label htmlFor={item.name} className="anvLabel">
                {item.name}
            </label>

            {Array.isArray(item.select) && item.check && (
                <div className="__tabFields_select">
                    {item.select.map((opt, index) => (
                        <div key={index} className="__tabFields_select_item">
                            <input
                                type="checkbox"
                                id={`${item.name}_${opt.name}`}
                                name={`${item.name}_select`}
                                checked={opt.check}
                                onChange={() => onToggleSelect(item.name, opt.name)}
                            />
                            <label htmlFor={`${item.name}_${opt.name}`}>{opt.name}</label>
                        </div>
                    ))}
                </div>
            )}
        </li>
    );
}

// ── Format preview map ───────────────────────────────────────────────────────
const FormatPreview = ({ form }) => {
    const map = {
        1: <Format1 modifyForm={form} />,
        2: <Format2 modifyForm={form} />,
        3: <Format3 modifyForm={form} />,
        4: <Format4 modifyForm={form} />,
        5: <Format5 modifyForm={form} />,
        6: <Format6 modifyForm={form} />,
        7: <Format7 modifyForm={form} />,
    };
    return map[form?.id] || null;
};

const LrSettingOffcanvas = ({
    show,
    onClose,
    form,
    setForm,
    companyId,
    branchId,
    onUpdateSuccess,
}) => {
    const [activeTab, setActiveTab] = useState(1);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
console.log(show)
    // ── Tab config ──────────────────────────────────────────────────────────
    const tabProps = {
        tabList: constant.lrSettingFormatTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab,
    };

    // ── DnD sensors ─────────────────────────────────────────────────────────
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
    );

    // ── Handlers ─────────────────────────────────────────────────────────────
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = form.lr_table.findIndex(i => i.name === active.id);
        const newIndex = form.lr_table.findIndex(i => i.name === over.id);

        if (oldIndex !== -1 && newIndex !== -1) {
            setForm(prev => ({
                ...prev,
                lr_table: arrayMove(prev.lr_table, oldIndex, newIndex),
            }));
        }
    };

    const onToggleMain = (name) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== name) return field;
                const newValue = !field.check;
                return {
                    ...field,
                    check: newValue,
                    select: Array.isArray(field.select)
                        ? field.select.map(opt => ({ ...opt, check: newValue ? opt.check : false }))
                        : field.select,
                };
            }),
        }));
    };

    const onToggleSelect = (parentName, optionName) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== parentName) return field;
                const updatedSelect = field.select.map(opt =>
                    opt.name === optionName ? { ...opt, check: !opt.check } : opt
                );
                return {
                    ...field,
                    check: updatedSelect.some(opt => opt.check) || field.check,
                    select: updatedSelect,
                };
            }),
        }));
    };

    // ── Update API ───────────────────────────────────────────────────────────
    const handleUpdate = async () => {
        const frDetailsWithoutImage = { ...form };
        delete frDetailsWithoutImage.imageUrl;

        const payload = {
            company_id: companyId,
            branch_id: branchId,
            format: frDetailsWithoutImage,
        };

        try {
            setIsUpdateLoading(true);
            const res = await addFormatApi(payload);
            if (res?.responseCode === 200) {
                toast.success(res?.responseMessage || 'Updated Successfully');
                onUpdateSuccess?.();   // parent ko notify karo — refetch + close
                onClose();
            } else {
                toast.error(res?.responseMessage || 'Update failed');
            }
        } catch (err) {
            toast.error(err?.message || 'Something went wrong');
        } finally {
            setIsUpdateLoading(false);
        }
    };

    // ── Render ───────────────────────────────────────────────────────────────
    // if (!form?.name) return null;

    return (
        <>
            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${show?._id ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: show ? 'visible' : 'hidden' }}
            >
                {/* Header */}
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title">LR Settings</h5>
                    <CrossButton
                        type="button"
                        className="_switchBtn __animEffect_btn"
                        onClick={onClose}
                        style={{ marginLeft: 'auto' }}
                    >
                        <CrossIcon />
                    </CrossButton>
                </div>

                {/* Body */}
                <div className="offcanvas-body" style={{ height: 'calc(100vh - 109px)' }}>
                    <div className="__frm_setting_cover">

                        {/* Format Preview */}
                        <div className="__frm_container">
                            <FormatPreview form={form} />
                        </div>

                        <div className="__frm_settFlx">
                            <div className="__frm_settInr">
                                <div className="addPr_flBx">
                                    <Tab {...tabProps} />

                                    {/* ── Tab 1: Address + LR Details ── */}
                                    {activeTab === 1 && (
                                        <div className="__frmSet_tabContent">
                                            <div>
                                                <h6>Address Details</h6>

                                                <div className="__template_type mb-4">
                                                    {['Company', 'Branch'].map(option => (
                                                        <div className="_dualCheckr_bx" key={option}>
                                                            <input
                                                                className="form-check-input"
                                                                id={option}
                                                                type="radio"
                                                                name="address"
                                                                value={option.toLowerCase()}
                                                                checked={form?.address?.toLowerCase() === option.toLowerCase()}
                                                                onChange={handleChange}
                                                            />
                                                            <label htmlFor={option} className="form-check-label">
                                                                {option}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="mb-4">
                                                    <CommonInput
                                                        type="text"
                                                        label="Item Description"
                                                        name="item_desc"
                                                        value={form.item_desc}
                                                        placeholder="Item Description"
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                <div className="mb-4">
                                                    <CommonTextarea
                                                        type="text"
                                                        label="Terms & Conditions"
                                                        name="terms_conds"
                                                        value={form.terms_conds}
                                                        placeholder="Terms & Conditions"
                                                        rows="4"
                                                        onChange={handleChange}
                                                        maxLength={180}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <h6>LR Details</h6>
                                                <DndContext
                                                    sensors={sensors}
                                                    collisionDetection={closestCenter}
                                                    onDragEnd={handleDragEnd}
                                                    modifiers={[restrictToVerticalAxis]}
                                                >
                                                    <SortableContext
                                                        items={form?.lr_table == null ? [] : form.lr_table.map(i => i.name)}
                                                        strategy={verticalListSortingStrategy}
                                                    >
                                                        <ul className="__tabFields_bx">
                                                            {form?.lr_table?.map(item => (
                                                                <SortableItem
                                                                    key={item.name}
                                                                    item={item}
                                                                    onToggleMain={onToggleMain}
                                                                    onToggleSelect={onToggleSelect}
                                                                />
                                                            ))}
                                                        </ul>
                                                    </SortableContext>
                                                </DndContext>
                                            </div>
                                        </div>
                                    )}

                                    {/* ── Tab 2: Copies ── */}
                                    {activeTab === 2 && (
                                        <div className="__frmSet_tabContent">
                                            {form?.copies?.map((i, index) => {
                                                const otherCopiesSelected = form.copies.some((copy, idx) => idx !== 0 && copy.check);
                                                const isOriginal = index === 0;
                                                const shouldBeChecked = isOriginal ? (otherCopiesSelected ? i.check : true) : i.check;
                                                const shouldBeDisabled = isOriginal && !otherCopiesSelected;

                                                return (
                                                    <div className="__copy_type mb-3" key={index}>
                                                        <input
                                                            type="checkbox"
                                                            name="LR_Details"
                                                            id={`copy_${index}`}
                                                            checked={shouldBeChecked}
                                                            disabled={shouldBeDisabled}
                                                            onChange={() => {
                                                                const updatedCopies = form.copies.map((c, ci) => {
                                                                    if (ci === index) {
                                                                        if (isOriginal && !otherCopiesSelected) return c;
                                                                        return { ...c, check: !c.check };
                                                                    }
                                                                    if (ci === 0 && !isOriginal) {
                                                                        const willHaveOther = form.copies.some((copy, idx) =>
                                                                            idx !== 0 && idx !== index && copy.check
                                                                        );
                                                                        if (!willHaveOther && form.copies[index].check) {
                                                                            return { ...c, check: true };
                                                                        }
                                                                    }
                                                                    return c;
                                                                });
                                                                setForm({ ...form, copies: updatedCopies });
                                                            }}
                                                        />
                                                        <label htmlFor={`copy_${index}`} className="anvLabel">
                                                            {i?.name}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="offcanvas-footer">
                                <button
                                    className="_addComm_btn"
                                    onClick={handleUpdate}
                                    disabled={isUpdateLoading}
                                >
                                    {isUpdateLoading ? 'Updating...' : 'Update'}
                                </button>
                                <button className="_cancel_btn" onClick={onClose}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop */}
            <div className={show ? 'offBack_drop' : ''} />
        </>
    );
};

export default LrSettingOffcanvas;